<template>
  <div class="legend-location-play">
    <div
      v-for="user in usersModified"
      v-bind:key="user.id"
      v-ifield-b-tooltip.hover="{
        title: $t('appAnalyzeLegendLocationPlay.tooltip.title'),
        placement: 'bottom',
        delay: { show: 500, hide: 0 },
      }"
    >
      <div
        class="legend-item"
        v-bind:class="{ disabled: !user.visible }"
        v-on:click="$_onClickUser(user.id)"
        v-on:mouseenter="$_onHoverUser(user.id)"
        v-on:mouseleave="$_onHoverUser(null)"
      >
        <img
          class="legend-icon"
          v-bind:src="user.icon"
          v-bind:alt="user.name"
        />
        <span class="legend-text"> {{ user.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppAnalyzeLegendLocationPlay',
  props: {
    /**
     * ユーザー
     */
    users: {
      type: Array,
      default: () => [],
    },
    /**
     * 表示状態
     */
    visible: {
      type: Object,
      default: () => ({ user: true }),
    },
  },
  computed: {
    /**
     * 加工したユーザー
     * - visibleの割当
     * @type {Array.<Object>}
     */
    usersModified: function () {
      return this.users.map((u) => ({
        ...u,
        visible:
          typeof this.visible.user === 'boolean'
            ? this.visible.user
            : this.visible.user[`${u.id}`],
      }))
    },
  },
  methods: {
    /**
     * ユーザークリック時処理
     * @param {Number} id ユーザーID
     */
    $_onClickUser: function (id) {
      const visible = Object.fromEntries(
        this.usersModified.map((u) => [u.id, u.visible])
      )
      visible[`${id}`] = !visible[`${id}`]
      /**
       * ユーザー表示状態変更イベント
       * @param {Object} visible 各ユーザーの表示状態
       */
      this.$emit('user-visible-changed', visible)
    },
    /**
     * ユーザーホバー時処理
     * @param {Number} id ユーザーID
     */
    $_onHoverUser: function (id) {
      /**
       * ユーザーホバー状態変更イベント
       * @param {Number} id ユーザーID
       */
      this.$emit('user-hover-changed', id)
    },
  },
}
</script>

<style lang="scss" scoped>
$-icon-size: 28px;

.legend-location-play {
  font-size: 0.875rem;
  row-gap: 16px;
  column-gap: 40px;
  display: grid;
  $-fit-length: calc(50% - 16px);
  grid-template-columns: fit-content($-fit-length) fit-content($-fit-length);
}

.legend-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;
  text-align: left;
  user-select: none;

  .legend-icon {
    flex-shrink: 0;
    flex-grow: 0;
    width: $-icon-size;
    height: $-icon-size;
  }

  .legend-text {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  &.disabled {
    .legend-icon {
      filter: saturate(0) contrast(50%) brightness(130%);
    }

    .legend-text {
      color: #cecece;
    }
  }
}
</style>
